export default "__VITE_PUBLIC_ASSET__f5a2b0aa__"